//import api from 'st-api/translation-api'
import { Store, createStore } from 'solid-js/store'
import { createEffect, createRoot, createSignal } from 'solid-js';

type Module = 'st' | 'pxp' | 'mtss' | 'txp';
type ModuleTranslations = Record<Module, Record<string, Record<string, string>>>;

//const [translation, setTranslation] = createStore({
//    language: '',
//    moduleTranslations: {} as ModuleTranslations,
//});

//export function loadTranslations<T extends (string | number | symbol)>(module: Module, componentName: string) {
//    if (!translation.moduleTranslations[module]) {
//        setTranslation('moduleTranslations', module, {});
//        createEffect(() => {
//            const mt = translation.moduleTranslations[module];
//        //    api.LoadTranslations(module, translation.language)
//        //        .then(translations => setTranslation('moduleTranslations', module, translations))
//        });
//    }

//    if (!translation.moduleTranslations[module][componentName]) {
//        createEffect(() => {
//            const mt = translation.moduleTranslations[module];
//            setTranslation('moduleTranslations', module, componentName, mt[componentName] || {});
//        });
//    }

//    return (key: T) => {
//        const mt = translation.moduleTranslations[module][componentName] as Record<T, string>;
//        if (mt[key] === undefined) {
//            setTranslation('moduleTranslations', module, componentName, key as string, '');
//        }

//        return mt[key];
//    }
//}

const [trnSettings, setTrnSettings] = createStore({ language: '' });
export function setLanguage(language: string) {
    setTrnSettings('language', language);
}

async function fetchTranslations(namespace: string, componentName: string): Promise<any> {
    const baseUrl = import.meta.env.DEV ? '/api/v1/translate' : 'api/v1/translate';
    let rootURL = ``;

    if (window.applicationRoot) {
        rootURL = `${location.origin}${window.applicationRoot}`;
    }

    const response = await fetch(`${rootURL}${baseUrl}/${namespace}/${componentName}`, {
        headers: {
            'Content-Type': 'application/json',
            'WINDOW_ID': window.name,
        },
        method: 'POST',
    });

    return await response.json();
}

const translationStores: Record<string, Store<unknown>> = {};
export function loadTranslations<T extends object>(namespace: string, componentName: string) : Store<T> {
    if (!translationStores[namespace]) {
        const [translation, setTranslation] = createStore<T>({} as T);
        translationStores[namespace] = [translation, setTranslation];

        createRoot(() => {
            createEffect(() => {
                fetchTranslations(namespace, componentName)
                    .then(setTranslation);
            });
        });
    }

    return translationStores[namespace] as Store<T>;
}

declare global {
    interface Window {
        loadTranslations: typeof loadTranslations;
    }
}

window.loadTranslations = loadTranslations;
